/**
  * 试题审核记录模块接口列表
  */

 import base from '../base'; // 导入接口域名列表
 import axios from '../../request/http'; // 导入http中创建的axios实例
 
 const testExamineApi = {
     GetExamQuestionsAuditList: `${base.qa}/ExamQuestion/GetExamQuestionsAuditList`,
     GetExamQuestionsAuditDetails: `${base.qa}/ExamQuestion/GetExamQuestionsAuditDetails`,
     ExamQuestionAudit: `${base.qa}/ExamQuestion/ExamQuestionAudit`,
 }
 
 const testExamine = {
     GetExamQuestionsAuditList (params) {
         let _newPar = {}
         for (const key in params) {
             if ((params[key] === 0 || params[key] === false || params[key]) && params[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
                 _newPar[key] = params[key];
             }
         }
         return axios.get(testExamineApi.GetExamQuestionsAuditList, { params: { state: _newPar.state, applyuser: _newPar.applyuser, startdate: _newPar.startdate, enddate: _newPar.enddate, pageindex: _newPar.pageindex, pagesize: _newPar.pagesize } })
     },
     GetExamQuestionsAuditDetails (params) {
         return axios.get(testExamineApi.GetExamQuestionsAuditDetails, { params: { auditid: params.auditid, pageindex: params.pageindex, pagesize: params.pagesize } })
     },
     ExamQuestionAudit (params) {
         console.log(params);
         return axios.post(testExamineApi.ExamQuestionAudit, params)
     },
 }
 
 
 export default testExamine;